"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isAuthenticatedCustomer = void 0;
var _constants = require("../constants");
var isAuthenticatedCustomer = function(customerId) {
    return customerId != null && customerId !== _constants.NOT_LOGGED_IN_USER_ID;
};
exports.isAuthenticatedCustomer = isAuthenticatedCustomer; //# sourceMappingURL=isAuthenticatedCustomer.js.map
